export default __webpack_public_path__ + "static/media/013_photo.b6e8c35e.jpg";